import React, {Component} from 'react'
import PropTypes from 'prop-types'
import ReactTable from 'react-table'
import {Button} from '@sabre/spark-react'
import formatFlightDate, {durationInMinutes} from '../../utils/formatFlightDate'
import 'shared/styles/table.css'

export default class FlightsTable extends Component {

    table = {
        title: 'Flights',
        columns: {
            callsign: 'Callsign',
            prefix: 'Prefix',
            number: 'Number',
            std: 'STD',
            departure: 'Departure',
            sta: 'STA',
            destination: 'Destination'
        },
        noData: 'No flights found'
    }

    columns() {
        return [
            {
                accessor: 'Callsign',
                id: 'Callsign',
                Header: this.table.columns.callsign,
                className: "spark-text-center"
            },
            {
                accessor: 'Prefix.icao',
                id: 'Prefix',
                Header: this.table.columns.prefix,
                className: "spark-text-center"
            },
            {
                accessor: 'Number',
                id: 'Number',
                Header: this.table.columns.number,
                className: "spark-text-center",
                sortMethod: (a, b) => {
                    if (a.length > b.length)
                    {
                        return 1;
                    }
                    else if (a.length < b.length)
                    {
                        return -1;
                    }
                    else
                    {
                        return a.localeCompare(b);
                    }

                },
            },
            {
                accessor: 'Departure.icao',
                id: 'Departure',
                Header: this.table.columns.departure,
                className: "spark-text-center"
            },
            {
                accessor: 'Destination.icao',
                id: 'Destination',
                Header: this.table.columns.destination,
                className: "spark-text-center"
            },
            {
                accessor: 'STD',
                Header: this.table.columns.std,
                id: 'STD',
                filterable: false,
                className: "spark-text-center",
                sortMethod: (a, b) => {
                    return durationInMinutes(a) > durationInMinutes(b) ? 1 : -1
                },
                Cell: row => (
                    <span className='std'>{formatFlightDate(row.original.Date, row.original.STD)}</span>
                )
            },
            {
                accessor: 'STA',
                Header: this.table.columns.sta,
                id: 'STA',
                filterable: false,
                className: "spark-text-center",
                sortMethod: (a, b) => {
                    return durationInMinutes(a) > durationInMinutes(b) ? 1 : -1
                },
                Cell: row => (
                    <span className='sta'>{formatFlightDate(row.original.Date, row.original.STA)}</span>
                )
            },
            {
                resizable: false, filterable: false, sortable: false, className: "spark-text-right", Cell: row => (
                    <span>
                        <Button onClick={() => this.props.actions.showBriefings(row.original.flightId)}
                                icon="spark-icon-documents"
                                title="Show Briefings" iconOnly/>
                    </span>
                )
            }
        ]
    }

    render() {
        return (
            <React.Fragment>
                <section className="spark-table">
                    <ReactTable className="condensed" columns={this.columns()}
                                loading={this.props.loading}
                                data={this.props.data}
                                defaultSorted={[{id: "STD"}]}
                                showPagination={true}
                                showPageJump={true}
                                showPageSizeOptions={true}
                                pageSizeOptions={[10, 25, 50, 100]}
                                minRows={10}
                                defaultPageSize={10}
                                noDataText={this.table.noData}
                                filterable={this.props.filters}
                                defaultFilterMethod={(filter, row) =>
                                    String(row[filter.id]).toUpperCase().startsWith(filter.value.toUpperCase())
                                }
                    />
                </section>
            </React.Fragment>
        )
    }
}

FlightsTable.propTypes = {
    actions: PropTypes.object.isRequired,
    loading: PropTypes.bool.isRequired,
    filters: PropTypes.bool.isRequired
}



// WEBPACK FOOTER //
// ./src/screens/flights/components/FlightsTable/index.js